import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { ColumnItem } from '../../../../components';
import { AdmIcon, OccupiedIcon, DischgIcon, BedAvailableIcon, AvgIcon } from '../../../../components/Icon';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '0.937rem',
    border: 'solid 1.2px #e4e7eb',
    padding: '0 1.625rem',
    flexWrap: 'wrap',
  },
}));

export default function StatuColumn() {
  const classes = useStyles();
  const [columnData] = useState([
    { id: 1, title: 'Adm. (from 09:00)', IconCom: AdmIcon, text: '1' },

    { id: 2, title: 'Dischg. (from 09:00)', IconCom: DischgIcon, text: '300' },
    { id: 3, title: 'Occupied', IconCom: OccupiedIcon, text: '10' },
    { id: 4, title: 'Bed available', IconCom: BedAvailableIcon, text: '120' },
    { id: 5, title: 'Missing', IconCom: AvgIcon, text: '2' },
  ]);
  const iconBgColors = ['#00a8f9', '#997bff', '#ff655c', '#44d7b6', '#fcb836'];

  return (
    <div className={classes.root} id="bed-status-column-box">
      {columnData.map((item, index) => {
        return <ColumnItem key={item.id} {...item} iconBgColor={iconBgColors[index]} />;
      })}
    </div>
  );
}
